import React from 'react'

const Footer = () => {
  return (
    <footer>
        <div className='footer-container'>
            <p>Projet réalisé par Ahmed - 2023</p>
            <p>Les icônes Wolverine, Iron-Man, Spider-Man et Batman sont prises sur iconFinder.com</p>
        </div>
    </footer>
  )
}

export default Footer